import {RequireAuth} from 'react-auth-kit'
import {Navigate, Route, Routes} from 'react-router-dom'
import {MasterLayout} from 'src/_metronic/layout/MasterLayout'
import {PromoLayout} from 'src/_metronic/layout/PromoLayout'

import * as Page from 'src/feature'

const PrivateRoutes = () => {
  const loginPath = '/sign-in'

  return (
    <Routes>
      <Route path='activate' element={<Page.ActivatePage />} />
      <Route path='sign-in' element={<Page.SignIn />} />
      <Route path='create-password' element={<Page.CreatePassword />} />
      <Route path='new-password' element={<Page.NewPassword />} />
      <Route path='forgot-password' element={<Page.ForgotPassword />} />
      <Route path='become-a-merchant' element={<Page.BecomeMerchant />} />
      <Route path='become-a-merchant/retail' element={<Page.Retail />} />
      <Route path='become-a-merchant/pricing' element={<Page.Pricing />} />
      <Route path='become-a-merchant/landing' element={<Page.Landing />} />
      <Route path='become-a-merchant/get-started' element={<Page.GetStarted />} />
      <Route path='become-a-merchant/merchant-form' element={<Page.MerchantForm />} />
      <Route path='become-a-merchant/success' element={<Page.PaymentSuccess />} />
      <Route element={<MasterLayout />}>
        <Route
          path='dashboard'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.Dashboard />
            </RequireAuth>
          }
        />
        <Route
          path='change-password'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.Profile />
            </RequireAuth>
          }
        />
        <Route
          path='task-in-progress'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.TasksInProgress />
            </RequireAuth>
          }
        />
        <Route
          path='import-tasks'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.ImportTasks />
            </RequireAuth>
          }
        />
        <Route
          path='members'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.Members />
            </RequireAuth>
          }
        />
        <Route
          path='members/:memberId'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.MemberDetail />
            </RequireAuth>
          }
        />
        <Route
          path='transaction/:transactionId'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.Transaction />
            </RequireAuth>
          }
        />
        <Route
          path='statement'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.Statement />
            </RequireAuth>
          }
        />
        <Route
          path='analytics'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.Analytics />
            </RequireAuth>
          }
        />
        <Route
          path='stores'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.StoreHome />
            </RequireAuth>
          }
        />
        <Route
          path='stores/:storeId'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.StoreDetail />
            </RequireAuth>
          }
        />
        <Route
          path='users/:userID'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.UserDetail />
            </RequireAuth>
          }
        />
        <Route
          path='referral'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.Referral />
            </RequireAuth>
          }
        />
        <Route
          path='terminals'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.Terminal />
            </RequireAuth>
          }
        />
        <Route
          path='terminals/:terminalId'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.TerminalDetail />
            </RequireAuth>
          }
        />
        <Route
          path='terminals/:terminalId/edit'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.EditTerminal />
            </RequireAuth>
          }
        />
        <Route
          path='terminals/new-terminal'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.AddNewTerminal />
            </RequireAuth>
          }
        />
        <Route
          path='vip/new-tier'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.NewVIPTier />
            </RequireAuth>
          }
        />
        <Route
          path='vip/edit/:tierId'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.EditVIPTier />
            </RequireAuth>
          }
        />
        <Route
          path='vip'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.VIP />
            </RequireAuth>
          }
        />
        <Route
          path='products'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.ProductHome />
            </RequireAuth>
          }
        />
        <Route
          path='products/new-product'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.AddNewProduct />
            </RequireAuth>
          }
        />
        <Route
          path='products/:productId'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.ProductDetail />
            </RequireAuth>
          }
        />
        <Route
          path='market-place'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.MarketPlace />
            </RequireAuth>
          }
        />
        <Route
          path='market-place/:productId'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.MarketPlaceDetail />
            </RequireAuth>
          }
        />
        <Route
          path='market-place/success'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.MarketPlaceSuccess />
            </RequireAuth>
          }
        />
        <Route
          path='market-place/cart'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.MarketPlaceCart />
            </RequireAuth>
          }
        />
        <Route
          path='market-place/checkout'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.MarketPlaceCheckout />
            </RequireAuth>
          }
        />
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
      <Route element={<PromoLayout />}>
        <Route
          path='campaign'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.Campaign />
            </RequireAuth>
          }
        />
        <Route
          path='engagement'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.Engagement />
            </RequireAuth>
          }
        />
        <Route
          path='help'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.Help />
            </RequireAuth>
          }
        />
      </Route>
    </Routes>
  )
}

export {PrivateRoutes}
